import { Dispatch } from "../../utility/common/storeHelper"
import { actions } from "./slice"
import { useLazyGetDialogTopicsQuery } from "../../api/controllers/dialogs"
import { MESSAGES_PER_PAGE } from "../../utility/dialogs/constant"

export const closeAllWorkplaceSidebars = () => (dispatch: Dispatch) => {
    dispatch(actions.closeKnowledgeBaseSidebar())
    dispatch(actions.closeArticleSidebar())
    dispatch(actions.closeFastRepliesSidebar())
    dispatch(actions.closeTopicsSidebar())
    dispatch(actions.closePreviousDialogSidebar())
    dispatch(actions.closeDialogHistorySidebar())
    dispatch(actions.closeChannelSelectSidebar())
    dispatch(actions.closeCreateClientSidebar())
    dispatch(actions.closeAddChannelToClientSidebar())
    dispatch(actions.closeDialogInfoSidebar())
}

export function backToDialogList() {
    return (dispatch: Dispatch) => {
        dispatch(actions.unsetCurrentDialogId())
        dispatch(actions.setCurrentClientOmniUserId())
    }
}

export function clearDialogsState() {
    return (dispatch: Dispatch) => {
        dispatch(actions.unsetCurrentDialogId())
        dispatch(actions.setCurrentClientOmniUserId())
    }
}

export function createDialog() {
    return (dispatch: Dispatch) => {
        dispatch(actions.unsetCurrentDialogId())
        dispatch(actions.setCurrentClientOmniUserId())
        dispatch(actions.setCurrentChannel())
        dispatch(actions.finishCreatingDialog())
        dispatch(closeAllWorkplaceSidebars())
        dispatch(actions.createDialog())
    }
}

export const closeKnowledgeBaseSidebar = () => {
    return (dispatch: Dispatch) => {
        dispatch(actions.closeArticleSidebar())
        dispatch(actions.closeKnowledgeBaseSidebar())
    }
}

export const switchToDialog =
    (
        dialogId: string,
        omniUserId: string,
        projectId: string,
        getTopics: ReturnType<typeof useLazyGetDialogTopicsQuery>[0]
    ) =>
    (dispatch: Dispatch) => {
        dispatch(actions.setCurrentClientOmniUserId(omniUserId))
        dispatch(actions.setCurrentDialogId(dialogId))
        dispatch(
            actions.setIsUserTyping({
                isTyping: false,
                message: ""
            })
        )

        dispatch(
            actions.setMessagesPaginationState({
                OmniUserId: omniUserId,
                StartTime: 0,
                Count: MESSAGES_PER_PAGE,
                FromTodayDialogs: true,
                ProjectId: projectId
            })
        )
        getTopics({
            ProjectId: projectId
        })
    }
